














import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "questionSettingTemplate",
  filters: {},
})
export default class questionSettingTemplate extends Vue {
  @Prop({
    type: String,
    default() {
      return {};
    },
  })
  typeText!: string;
}
